import { useCallback } from "react";
import { useSelector } from "react-redux";
import type { SortField } from "../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch.ts";
import { selectPreviewMode } from "../../../../store/selectors/currentReportSelectors";
import {
  selectColumns,
  selectPivotSettingsState,
  selectRows,
  selectSorts,
  selectValues,
} from "../../../../store/selectors/fieldsStateSelectors";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks.ts";
import type { PivotGridState } from "../../../viewer/pivot/hooks/gridState.types.ts";
import PreviewComponent from "../../../viewer/pivot/PreviewComponent.tsx";
import useCommonReportHandlers from "../../common/hooks/useCommonReportHandlers.ts";

interface Props {
  gridState: PivotGridState;
}

export default function EditPreviewComponent({ gridState }: Props) {
  const dispatch = useAppDispatch();
  const rowsAreaValues = useSelector(selectRows);
  const columnsAreaValues = useSelector(selectColumns);
  const valuesAreaValues = useSelector(selectValues);
  const settingsAreaValues = useSelector(selectPivotSettingsState);
  const sortsAreaValues = useSelector(selectSorts);
  const previewMode = useSelector(selectPreviewMode);
  const handlers = useCommonReportHandlers(valuesAreaValues);

  const handleSortingUpdate = useCallback(
    (sortFields: SortField[]) => {
      dispatch(fieldsStateActions.setSorting({ fields: sortFields, groupMetaNames: [] }));
    },
    [dispatch]
  );

  return (
    <PreviewComponent
      gridState={gridState}
      values={valuesAreaValues}
      rows={rowsAreaValues}
      columns={columnsAreaValues}
      sorts={sortsAreaValues}
      previewMode={previewMode}
      settings={settingsAreaValues}
      onDrillDown={handlers.onDrillDown}
      onSortingUpdate={handleSortingUpdate}
    />
  );
}
